import * as Api from '@ViewModels';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'CustomPageStyle/get/{type}';

export const useGetBlogStylesByTypeQuery = ({
	type,
	impersonationContext,
	enabled = true,
	meta,
}: {
	type: Api.CustomPageType;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			try {
				const value = await userSession.webServiceHelper.callAsync<Api.CustomBlogStyles>(
					Api.ImpersonationBroker.composeApiUrl({
						urlPath: `CustomPageStyle/${encodeURIComponent(type)}`,
						impersonationContext,
					}),
					'GET'
				);
				return value;
			} catch (networkError) {
				const apiError = Api.asApiError(networkError);
				if (apiError.systemCode === 404) {
					return null;
				}
				throw networkError;
			}
		},
		queryKey: [BASE_QUERY_KEY, type, impersonationContext],
		staleTime: 30000,
		placeholderData: keepPreviousData,
		meta,
	});
};

export const invalidateAllGetBlogStylesByTypeQueries = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};

export const invalidateGetBlogStylesByTypeQueries = (type: Api.CustomPageType) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, type] });
};
